import {Popover, Tooltip} from "@blueprintjs/core";
import styled from "@emotion/styled";
import {CSSProperties} from "react";
import {DriverQualification} from "../../../../../../../generated/graphql";

const DriverQualificationContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 3px;
  text-transform: uppercase;
  background-color: #e5e6e6;
  padding: 3px 4px;
  border-radius: 4px;
`;

const DriverQualificationContent = styled.div`
  cursor: pointer;
  font-family: Roboto;
  font-size: 11px;
  line-height: 11px;
  font-weight: 500;
  color: #797979;
`;

const DriverQualificationPopoverContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 3px;
`;

type NewDriverQualTagProps = {
  qualification: DriverQualification;
  mimimal?: boolean;
};

const DriverQualTagV3 = ({qualification, mimimal = false}: NewDriverQualTagProps) => {
  const styles: CSSProperties = mimimal
    ? {}
    : {textTransform: "uppercase", backgroundColor: "#e5e6e6", padding: "3px 4px", borderRadius: "4px"};

  return (
    <DriverQualificationContent>
      {(qualification.name?.length as number) > 3 ? (
        <Tooltip content={qualification.name ?? ""} position="bottom" popoverClassName="manifest-card-header-popover">
          <DriverQualificationContent style={styles}>{qualification.name?.substring(0, 3)}</DriverQualificationContent>
        </Tooltip>
      ) : (
        <DriverQualificationContent style={styles}>{qualification.name?.substring(0, 3)}</DriverQualificationContent>
      )}
    </DriverQualificationContent>
  );
};

type DriverQualificationProps = {
  qualifications: DriverQualification[];
};

const DriverQualV3 = ({qualifications}: DriverQualificationProps) => {
  return qualifications.length > 0 ? (
    <DriverQualificationContainer>
      <DriverQualTagV3 qualification={qualifications[0]} mimimal />
      {qualifications.length > 1 && (
        <Popover
          interactionKind="hover"
          placement="top"
          popoverClassName="manifest-card-header-popover"
          content={
            <DriverQualificationPopoverContent>
              {qualifications.map((qual) => (
                <DriverQualTagV3 key={`qualification-tag-${qual.id}`} qualification={qual} />
              ))}
            </DriverQualificationPopoverContent>
          }
        >
          <DriverQualificationContent data-testid="driver-capabilities">{`+${
            qualifications.length - 1
          }`}</DriverQualificationContent>
        </Popover>
      )}
    </DriverQualificationContainer>
  ) : null;
};

export default DriverQualV3;
